export const checkIfLoading = (store, ...actionsToCheck) =>
  store.loader.actions.some(action => actionsToCheck.includes(action.name));

export const checkIfRefreshing = (store, actionToCheck) =>
  store.loader.refreshing.some(action => action === actionToCheck);

export const checkIfAnyLoading = (store) =>
  store.loader.actions.length